import React, { useMemo } from "react";
import StyledModal from "../../components/CustomModal";
import { Form, FormInstance, Switch } from "antd";
import { useAppSelector } from "../../utils/hooks/redux";
import { FooterButtons, FormWrapper, StyledButton } from "../../components/styles";
import { Label, StyledTextArea } from "../../components/Input/styles";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { selectDeleteReason } from "../../redux/features/deleteReason/deleteReasonSlice";

type EditReasonModalProps = {
  isModalOpen: boolean;
  handleSave: (values: any) => void;
  onCancel: () => void;
  form: FormInstance<any>;
  hasEditPermission?: boolean;
  hasViewPermission?: boolean;
  hasAddPermission?: boolean;
};

const EditReasonModal: React.FC<EditReasonModalProps> = ({ isModalOpen, handleSave, onCancel, form, hasEditPermission, hasViewPermission, hasAddPermission }) => {
  const { loading } = useAppSelector(selectDeleteReason);
  const canSaveChanges = useMemo(() => hasAddPermission || hasEditPermission, [hasAddPermission, hasEditPermission]);

  return (
    <StyledModal
      draggable={true}
      title={form.getFieldValue("id") ? `${canSaveChanges ? "Edit" : "View"} Reason` : `${canSaveChanges ? "Add" : "View"} Reason`}
      open={isModalOpen}
      closeIcon={null}
      footer={
        <FooterButtons>
          <StyledButton onClick={onCancel} disabled={loading}>
            Cancel
          </StyledButton>
          {canSaveChanges && <StyledButton
            type="primary"
            onClick={async () => {
              try {
                const values = await form.validateFields(["reason", "showInPortal"]);
                handleSave(values);
              } catch (error) {
                console.error("Validation failed:", error);
              }
            }}
            loading={loading}
          >
            Save
          </StyledButton>}
        </FooterButtons>
      }
      centered
      onCancel={() => !loading && onCancel()}
    >
      <FormWrapper form={form} layout="vertical" disabled={!canSaveChanges}>
        <Form.Item
          name="reason"
          rules={[
            {
              required: true,
              message: "Please enter reason for deletion.",
            },
          ]}
          label={<Label fontWeight="700">Reason</Label>}
        >
          <StyledTextArea
            placeholder="Reason"
            height="85px"
            onChange={(e: any) => {
              form.setFieldsValue({
                reason: e?.target?.value,
              });
            }}
            disabled={!canSaveChanges}
          />
        </Form.Item>
        <Form.Item
          name="showInPortal"
          label={<Label fontWeight="700">Show in Customer Portal</Label>}
          valuePropName="checked"
          initialValue={true}
        >
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            disabled={!canSaveChanges}
          />
        </Form.Item>
      </FormWrapper>
    </StyledModal>
  );
};

export default EditReasonModal;
